import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ProfileSubpage from 'Views/Page/Content/Templates/Profile/Templates/ProfileSubpage';
import fr from 'facet-rest';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import AuthenticationFactorList
  from 'Views/Page/Content/Templates/SettingsTemplate/Content/AuthenticationFactorTemplate/AuthenticationFactorsCard/AuthenticationFactorListPicker/AuthenticationFactorList';
import { root, content } from '../subpageClasses';

const useStyles = buildUseStyles('Security', (theme) => ({
  // Main Classes
  root: root(theme),
  content: content(theme, { alignItems: 'center' }),
}));

const SecurityProfileSubpage = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const profilePageRelationship = resource.relationship(fr.relationships.householdMembershipPage.name);
  const backLabel = profilePageRelationship?.meta('prompt');
  const backLink = profilePageRelationship?.link('related');

  return (
    <ProfileSubpage
      className={classNames(classes.root, className)}
      title={resource.attr('title')}
      description={resource.attr('subtitle')}
      backLabel={backLabel}
      backLink={backLink}
    >
      <Box className={classes.content}>
        <AuthenticationFactorList />
      </Box>
    </ProfileSubpage>
  );
};

SecurityProfileSubpage.defaultProps = {
  className: '',
};

SecurityProfileSubpage.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default SecurityProfileSubpage;
